import React, { Fragment, useEffect, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import Arrow from "../shared/arrow";
import { __t } from "../../utils/translate";


const options = [
    { orderOption: __t("Oldest"), name: "oldest" },
    { orderOption: __t("Newest"), name: "newest" },
    { orderOption: __t("Highest rated"), name: "highest_rated" },
    { orderOption: __t("Lowest rated"), name: "lowest_rated" },
] as const;

type Option = (typeof options)[number];

export type ReviewOrderActionsType =
    | "newest"
    | "highest_rated"
    | "lowest_rated"
    | "oldest";

type SelectReviewOrderProps = {
    onSelect: React.Dispatch<ReviewOrderActionsType>;
};

const SelectReviewOrder: React.FC<SelectReviewOrderProps> = ({ onSelect }) => {
    const [selected, setSelected] = useState<Option>(options[0]);
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    const handleChange = (value: Option) => {
        onSelect(value.name);
        setSelected(value);
    };

    if (!hasMounted) {
        return null;
    }

    return (
        <div className="relative z-10 w-full p-4 text-small-14 bg-[#f6f6f6]">
            <div className="w-full md:my-1">
                <Listbox value={selected} onChange={handleChange}>
                    <div className="relative">
                        <Listbox.Button className="flex flex-row justify-between items-center w-full h-[48px] md:h-fit md:max-w-[400px] cursor-pointer text-left bg-white border-[1px] border-gray p-[5px] focus:border-button-accent-color focus:border-2">
                            {({ open }) => (
                                <>
                                    <span className="block truncate text-dark">{selected.orderOption}</span>
                                    <span className="pointer-events-none flex items-center">
                                        <Arrow className="!w-[14px] !h-[14px] mr-3" isActive={open} />
                                    </span>
                                </>
                            )}
                        </Listbox.Button>
                        <Transition
                            as={Fragment}
                            enter="transition-all ease duration-500"
                            enterFrom="opacity-0 h-0"
                            enterTo="opacity-100 h-[200px]"
                            leave="transition-all ease duration-500"
                            leaveFrom="opacity-100 h-[200px]"
                            leaveTo="opacity-0 h-0"
                        >
                            <Listbox.Options className="absolute top-12 lg:top-8 h-fit w-full translate-y-[-1px] md:max-w-[400px] overflow-hidden bg-white text-small-14 text-dark-blu shadow-xl border-[1px] border-gray rounded-b-md">
                                <span className={`block text-small-14 font-bold py-1 px-2 text-dark`}>{__t('Sort reviews by')}:</span>
                                {options.map((option, optionIdx) => (
                                    <Listbox.Option
                                        key={optionIdx}
                                        className={({ active, selected }) =>
                                            `px-4 flex flex-row justify-between py-[6px] ${active ? "bg-[#82caf8] text-white select-none" : ""
                                            } ${selected ? "bg-[#82caf8] text-white select-none" : "cursor-pointer"}`
                                        }
                                        value={option}
                                    >
                                        {({ selected }) => (
                                            <>
                                                <span className={`block truncate`}>{option.orderOption}</span>
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </Listbox>
            </div>
        </div>
    );
};

export default SelectReviewOrder;
